<template>
  <div>
    <v-client-table
      :data="tableItems"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': tablePreloader }"
    >
      <template #h__supplier><div class="table-default__left">Supplier</div></template>
      <template #source="{ row }">{{ row.source.name }}</template>
      <template #verification_code="{ row }">
        <button
          @click="onCopyToClipboard(row.verification_link)"
          class="table-default__copy"
          :class="{'table-default__copy--disabled': !row.verification_link}"
        >
          {{ row.verification_code }}
        </button>
      </template>
      <template #date="{ row }"><span class="table-default__nowrap">{{ formatDate(row.date) }}</span></template>
      <template #time="{ row }">{{ row.time || '-' }}</template>
      <template #supplier="{ row }">
        <div class="table-default__left">
          <router-link
            :to="{ name: 'administrative-suppliers-detail-purchases', params: { id: row.supplier.id } }"
            class="table-default__link-inline"
          >
            {{ row.supplier.trade_name }}
          </router-link>
        </div>
      </template>
      <template #amount_total="{ row }">{{ amountFormat(row.amount_total) }}</template>
      <template #amount_vat_exc="{ row }">{{ amountFormat(row.amount_vat_exc) }}</template>
      <template #amount_vat="{ row }">{{ amountFormat(row.amount_vat) }}</template>
      <template #receipt_copy="{ row }">
        <a
          :class="{'table-default__disabled': !row.receipt_copy}"
          :href="row.receipt_copy?.file"
          target="_blank"
        >
          <img alt="Attachment" src="@/assets/img/snacks-link.svg">
        </a>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="$emit('clickPagination', $event)"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination.count" :count="tableItems.length" :page="pagination.page" />
    </app-cells>
  </div>
</template>

<script>
export default {
  name: 'TableDetailEFDPurchases',
  props: ['tableItems', 'tablePreloader', 'pagination', 'formatDate', 'amountFormat'],
  data() {
    return {
      table: {
        items: [],
        columns: [
          'receipt_copy',
          'source',
          'verification_code',
          'date',
          'time',
          'supplier',
          'amount_total',
          'amount_vat_exc',
          'amount_vat',
        ],
        options: {
          headings: {
            'receipt_copy': 'Receipt',
            'source': 'Source',
            'verification_code': 'Verification code',
            'date': 'Date',
            'time': 'Time',
            'supplier': 'Supplier',
            'amount_total': 'Total amount',
            'amount_vat_exc': 'VAT Exclude',
            'amount_vat': 'VAT',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  methods: {
    onCopyToClipboard(string) {
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
  }
}
</script>

